/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * faction object
 * @export
 * @interface PostUniverseIdsFaction
 */
export interface PostUniverseIdsFaction {
    /**
     * id integer
     * @type {number}
     * @memberof PostUniverseIdsFaction
     */
    id?: number;
    /**
     * name string
     * @type {string}
     * @memberof PostUniverseIdsFaction
     */
    name?: string;
}

/**
 * Check if a given object implements the PostUniverseIdsFaction interface.
 */
export function instanceOfPostUniverseIdsFaction(value: object): value is PostUniverseIdsFaction {
    return true;
}

export function PostUniverseIdsFactionFromJSON(json: any): PostUniverseIdsFaction {
    return PostUniverseIdsFactionFromJSONTyped(json, false);
}

export function PostUniverseIdsFactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostUniverseIdsFaction {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function PostUniverseIdsFactionToJSON(json: any): PostUniverseIdsFaction {
    return PostUniverseIdsFactionToJSONTyped(json, false);
}

export function PostUniverseIdsFactionToJSONTyped(value?: PostUniverseIdsFaction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

